import PropTypes from "prop-types";
import { Chip } from "@mui/material";

import { getHighestRole } from "utils/userPermissions";

export default function ProjectRoleLabel({ projectRoles }) {
  ProjectRoleLabel.propTypes = {
    projectRoles: PropTypes.object.isRequired,
  };

  const highestRole = getHighestRole(projectRoles);
  const activeProjectRoleLabel = highestRole?.label;

  return <Chip sx={{ ml: 1 }} label={activeProjectRoleLabel} size="small" />;
}
